import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Projects.scss";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { uiSliceActions } from "../../redux/reducers/uiState";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import RunningProjects from "./RunningProjects";
import CompletedProjects from "./CompletedProjects";
import CreateProject from "./CreateProject";
import ManageProject from "./ManageProject";
import ProjectFinancialInfo from "./ProjectFinancialInfo";
import MangeProjectFinancialInfo from "./MangeProjectFinancialInfo";

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    // backgroundColor: theme.palette.background.paper,
  },
}));

const Projects = () => {
  // ----------------for tab-------------------
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(uiSliceActions.setFinancialEdit({}));
    dispatch(uiSliceActions.setInitial());
    dispatch(uiSliceActions.setWorkOrderItemInitialState());
    dispatch(uiSliceActions.setInitalIsworkItem());
    // eslint-disable-next-line
  }, [value]);

  return (
    <Sidebar>
      <Grid container className="projects_wrapper">
        <Grid item xs={12}>
          {/* -------------------Tab Area---------- */}
          <Grid className={`${classes.root} ml`}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab label="Running Projects" {...a11yProps(0)} />
              <Tab label="Completed Projects" {...a11yProps(1)} />
              <Tab label="Create and Manage Projects" {...a11yProps(2)} />
              <Tab label="Project Financial Information" {...a11yProps(3)} />
            </Tabs>
            <TabPanel value={value} index={0}>
              <Grid container className="first_tab_content">
                <RunningProjects />
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Grid container className="second_tab_content">
                <CompletedProjects />
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Grid className="third_tab_content">
                <CreateProject />
                <ManageProject />
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={3}>
              <Grid className="fourth_tab_content">
                <ProjectFinancialInfo />
                <MangeProjectFinancialInfo />
              </Grid>
            </TabPanel>
          </Grid>
        </Grid>
      </Grid>
    </Sidebar>
  );
};

export default Projects;
